import styled from 'styled-components'
import { colors, derivedColors } from '../../const'
import { withDisabledButtonStyled } from '../../const/styles'

export const Card = styled.div`
  background-color: ${colors.surface};
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0.5rem;
  width: 100%;

  &:hover {
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  }
`

export const CardContent = styled.div`
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const Title = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin-bottom: 8px;
`

export const Description = styled.p`
  font-size: 0.875rem;
  color: ${colors.textSecondary};
  margin: 0 auto 24px;
  flex-grow: 1;
  display: inline-block;
  max-width: 12rem;
`

export const ActionButton = styled.button`
  width: 100%;
  background-color: ${colors.primary};
  color: ${colors.surface};
  padding: 10px 0;
  border: none;
  border-radius: 0.375rem;
  font-weight: 550;
  cursor: pointer;
  margin-top: 18px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.primaryHover};
  }

  ${withDisabledButtonStyled}
`

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  background-color: ${derivedColors.transparentSecondary};
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 4px;

  & > svg {
    width: 32px;
    height: 32px;
    color: ${colors.primary};
  }
`
